import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';

import { CookieOptions, CookieService } from 'ngx-cookie';
import * as CryptoJS from 'crypto-js';
import { Observable, retry } from 'rxjs';
import { HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class AppB2cService {
  private _document = inject(DOCUMENT);
  private _cookieService = inject(CookieService);
  private _http = inject(HttpClient);


  public serverBaseUrl = this.getServerBaseUrl;
  private chatUrl = this.getServerBaseUrl + '/Chat';

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
  }

  public get getServerBaseUrl(): string {
    let url = environment.baseUrlADB2CApi;

    if (this._document.location.host.indexOf("demo.") >= 0)
      url = environment.baseUrlADB2CApi;
    else if (this._document.location.host.indexOf("-dev") >= 0)
      url = environment.baseUrlADB2CApi;
    else
      url = environment.baseUrlADB2CApi;

    return url;
  }

  getHeaders(): HttpHeaders {
    let authToken = this.getCookie('authToken');

    return new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Accept': '*/*',
      'Authorization': `Bearer ${authToken}`
    });
  }

  startChat(params: any): Observable<any> {
    const url = `${this.chatUrl}/StartChat`;
    const httpOptions = { headers: this.getHeaders() };

    return this._http.post(url, params, httpOptions).pipe(
      retry(2)
    );
  }

  startProviderChat(params: any): Observable<any> {
    const url = `${this.chatUrl}/StartChatServiceProvider`;
    const httpOptions = { headers: this.getHeaders() };

    return this._http.post(url, params, httpOptions).pipe(
      retry(2)
    );
  }

  sendMessage(params: any): Observable<any> {
    const url = `${this.chatUrl}/SendMessage`;
    const httpOptions = { headers: this.getHeaders() };

    return this._http.post(url, params, httpOptions).pipe(
      retry(2)
    );
  }



  //#region Cookie
  /**
* @param {string} key Id to use for lookup.
* @returns {string} Raw cookie value.
*/
  getCookie(key: string) {
    let cookie = this._cookieService.get(key);

    try {
      const decryptedValue = this.decryptValue(cookie);
      return decryptedValue && decryptedValue.trim().length > 0 ? decryptedValue : cookie;

    } catch (e) {
      return cookie;
    }
  }



  encryptValue(value: string): string {
    const key = CryptoJS.enc.Utf8.parse(environment.cryptingKey);
    const encrypted = CryptoJS.AES.encrypt(value, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  }


  decryptValue(value: string): string {
    const key = CryptoJS.enc.Utf8.parse(environment.cryptingKey);
    const decrypted = CryptoJS.AES.decrypt(value, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  //#endregion
}
